export default "__VITE_ASSET__Cxg8onvA__"